import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {CacheService, Location, SettingsService} from "@customcoding/shared";

@Injectable({
	providedIn: 'root'
})
export class CompanyLocationsService {

	id = this.settings.get('SCAP_COMPANY_ID');

	constructor(private http: HttpClient,
							private cache: CacheService,
							private settings: SettingsService) {
	}

	getSCAPLocations(): Observable<Location[]> {
		if (this.id){
			return this.http.get<Location[]>(`/api/location?filter[company_id]=${this.id}`);
		} else {
			return of([]);
		}
	}

	getSCAPLocationsCache(): Observable<Location[]> {
		if (this.id) {
			return this.cache.get<Location[]>(`/api/location?filter[company_id]=${this.id}`);
		} else {
			return of([]);
		}
	}
}
